import React from 'react';

import MainContent from '../components/layout/MainContent';
import Title from '../components/typography/Title';

import NavContainer from '../containers/NavContainer';

import { createFetchingView } from '../helpers/views';

class NotFoundView extends React.PureComponent {
  renderContent() {
    return (
      <MainContent
        id="NotFoundView"
        style={{ maxWidth: '1408px' }}
        className="sk-fade-in-quarter-second"
      >
        <Title align="center">Page Not Found</Title>
        <NavContainer />
      </MainContent>
    );
  }

  render() {
    if (this.props.isReady) {
      return this.renderContent();
    }

    return null;
  }
}

export default createFetchingView(NotFoundView);



// WEBPACK FOOTER //
// ./src/views/NotFoundView.js